export default __webpack_public_path__ + "table-section.png";